export const codeOptions = [
    { value: '0', label: '0' },
    { value: '200', label: '200' },
    { value: '201', label: '201' },
    { value: '202', label: '202' },
    { value: '301', label: '301' },
    { value: '302', label: '302' },
    { value: '303', label: '303' },
    { value: '304', label: '304' },
    { value: '204', label: '204' },
    { value: '400', label: '400' },
    { value: '401', label: '401' },
    { value: '403', label: '403' },
    { value: '404', label: '404' },
    { value: '405', label: '405' },
    { value: '406', label: '406' },
    { value: '407', label: '407' },
    { value: '408', label: '408' },
    { value: '409', label: '409' },
    { value: '410', label: '410' },
    { value: '411', label: '411' },
    { value: '412', label: '412' },
    { value: '413', label: '413' },
    { value: '414', label: '414' },
    { value: '415', label: '415' },
    { value: '416', label: '416' },
    { value: '417', label: '417' },
    { value: '421', label: '421' },
    { value: '422', label: '422' },
    { value: '426', label: '426' },
    { value: '428', label: '428' },
    { value: '429', label: '429' },
    { value: '431', label: '431' },
    { value: '500', label: '500' },
    { value: '501', label: '501' },
    { value: '502', label: '502' },
    { value: '503', label: '503' },
    { value: '504', label: '504' },
    { value: '505', label: '505' },
    { value: '506', label: '506' },
    { value: '507', label: '507' },
    { value: '508', label: '508' },
    { value: '510', label: '510' },
    { value: '511', label: '511' },
];

export const messageOptions = [
    { value: 'OK', label: 'OK' },
    { value: 'Created', label: 'Created' },
    { value: 'Accepted', label: 'Accepted' },
    { value: 'Moved Permanently', label: 'Moved Permanently' },
    { value: 'Moved Found', label: 'Moved Found' },
    { value: 'See Other', label: 'See Other' },
    { value: 'Not Modified', label: 'Not Modified' },
    { value: 'No Content', label: 'No Content' },
    { value: 'Bad Request', label: 'Bad Request' },
    { value: 'Bad Unauthorized', label: 'Bad Unauthorized' },
    { value: 'Forbidden', label: 'Forbidden' },
    { value: 'Not Found', label: 'Not Found' },
    { value: 'Method Not Allowed', label: 'Method Not Allowed' },
    { value: 'Not Acceptable', label: 'Not Acceptable' },
    { value: 'Proxy Authentication Required', label: 'Proxy Authentication Required' },
    { value: 'Request Timeout', label: 'Request Timeout' },
    { value: 'Conflict', label: 'Conflict' },
    { value: 'Gone', label: 'Gone' },
    { value: 'Length Required', label: 'Length Required' },
    { value: 'Precondition Failed', label: 'Precondition Failed' },
    { value: 'Payload Too Large', label: 'Payload Too Large' },
    { value: 'URI Too Long', label: 'URI Too Long' },
    { value: 'Unsupported Media Type', label: 'Unsupported Media Type' },
    { value: 'Range Not Satisfiable', label: 'Range Not Satisfiable' },
    { value: 'Expectation Failed', label: 'Expectation Failed' },
    { value: 'Misdirected Request', label: 'Misdirected Request' },
    { value: 'Unprocessable Content', label: 'Unprocessable Content' },
    { value: 'Upgrade Required', label: 'Upgrade Required' },
    { value: 'Precondition Required', label: 'Precondition Required' },
    { value: 'Too Many Requests', label: 'Too Many Requests' },
    { value: 'Request Header Fields Too Large', label: 'Request Header Fields Too Large' },
    { value: 'Internal Server Error', label: 'Internal Server Error' },
    { value: 'Not Implemented', label: 'Not Implemented' },
    { value: 'Bad Gateway', label: 'Bad Gateway' },
    { value: 'Service Unavailable', label: 'Service Unavailable' },
    { value: 'Gateway Timeout', label: 'Gateway Timeout' },
    { value: 'HTTP Version Not Supported', label: 'HTTP Version Not Supported' },
    { value: 'Variant Also Negotiates', label: 'Variant Also Negotiates' },
    { value: 'Insufficient Storage', label: 'Insufficient Storage' },
    { value: 'Loop Detected', label: 'Loop Detected' },
    { value: 'Not Extended', label: 'Not Extended' },
    { value: 'Network Authentication Required', label: 'Network Authentication Required' },
    { value: 'Ошибка определения IP адреса в DNS', label: 'Ошибка определения IP адреса в DNS' },
    { value: 'Не удалось установить соединение', label: 'Не удалось установить соединение' },
    { value: 'Таймаут подключения', label: 'Таймаут подключения' },
    { value: 'Ошибка сертификата SSL', label: 'Ошибка сертификата SSL' },
    { value: 'Пустой ответ сервера', label: 'Пустой ответ сервера' },
    { value: 'Соединение было сброшено', label: 'Соединение было сброшено' },
    { value: 'Соединение отклонено', label: 'Соединение отклонено' },
    { value: 'Циклические перенаправления', label: 'Циклические перенаправления' },
];